// 履约状态枚举
export enum PerformanceType {
  NOT_START = 1,
  NO_NEED,
  TO_BE_NOTIFIED,
  PARTIAL_NOTIFICATION,
  NOTIFIED,
  PARTIAL_SHIPMENT,
  SHIPMENT,
  PARTIAL_RECEIPT,
  RECEIPT,
  COMPLETED,
  TERMINATED,
}
//待通知、部分通知、已通知、部分发货、部分收货、已收货、已完成、已终止
export enum PerformanceTypeName {
  NOT_START = '未开始',
  NO_NEED = '无需履约',
  TO_BE_NOTIFIED = '待通知',
  PARTIAL_NOTIFICATION = '部分通知',
  NOTIFIED = '已通知',
  PARTIAL_SHIPMENT = '部分发货',
  SHIPMENT = '已发货',
  PARTIAL_RECEIPT = '部分收货',
  RECEIPT = '已收货',
  COMPLETED = '已完成',
  TERMINATED = '已终止',
}
// 订单状态枚举 创建中、待审批、已审批、已驳回、已关闭、已取消
export enum OrderType {
  CREATE_NEW = 1,
  PENDING_REVIEW = 2,
  REJECTED = 3,
  APPROVED = 4,
  // PENDING = 5,
  CANCELED = 5,
  CLOSED = 6,
}

export enum OrderTypeName {
  CREATE_NEW = '创建中',
  PENDING_REVIEW = '待审核',
  REJECTED = '已驳回',
  APPROVED = '已审核',
  // PENDING = '挂起',
  CANCELED = '已取消',
  CLOSED = '已关闭',
}
/**
 * 涉及tags，新增颜色
 */
export enum OrderTypeColor {
  CREATE_NEW = 'green',
  PENDING_REVIEW = 'blue',
  REJECTED = 'red',
  APPROVED = 'lime',
  // PENDING = '挂起',
  CANCELED = 'orange',
  CLOSED = 'purple',
}

// 订单标识
export enum OrderSign {
  ORDINARY = 1,
  URGENT = 2,
  // STRAIGHT_HAIR = 3,
  //   ONE_PIECE = 4,
  // ON_DEMAND = 5,
  // ON_ORDER = 6,
  SELF_PICKUP = 7,
}

// 1-普通订单 2-急件订单 3-直发订单 4-一件代发 5-按需发货 6-按单发货 7-自提订单

export enum OrderSignName {
  ORDINARY = '普通订单',
  URGENT = '急件订单',
  // STRAIGHT_HAIR = '直发订单',
  //   ONE_PIECE = '一件代发',
  // ON_DEMAND = '按需发货',
  // ON_ORDER = '按单发货',
  SELF_PICKUP = '自提订单',
}

//支付状态
export enum PaymentStatus {
  UNPAID = 1, // 待支付
  PARTIAL = 2, // 部分支付
  PAID = 3, // 已支付
}
export enum PaymentStatusName {
  UNPAID = '待支付', // 待支付
  PARTIAL = '部分支付', // 部分支付
  PAID = '已支付', // 已支付
}
/**
 * 支付状态，tags颜色
 */
export enum PaymentStatusColor {
  UNPAID = 'red', // 待支付
  PARTIAL = 'blue', // 部分支付
  PAID = 'green', // 已支付
}

//订单来源类型
export enum OrderSource {
  MANUAL = '1', // 人工新增订单
  PURCHASE_ORDER = '2', // 采购单
  ALLOCATION = '3', // 主配单
  AFTER_SALE = '4', // 售后申请单
  CHANNEL = '5', // 渠道原始订单
}
export enum OrderSourceName {
  MANUAL = '人工新增订单', // 人工新增订单
  PURCHASE_ORDER = '采购单', // 采购单
  ALLOCATION = '主配单', // 主配单
  AFTER_SALE = '售后申请单', // 售后申请单
  CHANNEL = '渠道原始订单', // 渠道原始订单
}

//订单来源平台
export enum OrderSourcePlatform {
  ERP = 1,
  Platform = 2,
}
export enum OrderSourcePlatformName {
  ERP = 'ERP',
  Platform = '芸台购',
}
// 挂起状态
export enum PendingType {
  NOT = 0,
  FULL_ORDER = 2,
  PARTIAL = 1,
}

export enum PendingTypeName {
  NOT = '未挂起',
  FULL_ORDER = '整单挂起',
  PARTIAL = '部分挂起',
}
/**
 * 挂起状态的tags颜色
 */
export enum PendingTypeColor {
  NOT = 'red',
  FULL_ORDER = 'blue',
  PARTIAL = 'green',
}

//组合标识
export enum CombinationIdentifier {
  PARENT_ORDER = 1,
  CHILD_ORDER = 2,
  VIRTUAL_PARENT_ORDER = 3,
  VIRTUAL_CHILD_ORDER = 4,
}
export enum CombinationIdentifierName {
  PARENT_ORDER = '实物父项',
  CHILD_ORDER = '实物子项',
  VIRTUAL_PARENT_ORDER = '虚拟父项',
  VIRTUAL_CHILD_ORDER = '虚拟子项',
}
// 贸易类型
export enum TradeType {
  DOMESTIC = 1,
  CROSS_BORDER = 2,
}

export enum TradeTypeName {
  DOMESTIC = '国内贸易',
  CROSS_BORDER = '跨境贸易',
}
//业务属性
export enum BizAttrType {
  // TEACHING_MATERIAL = 1,
  // E_COMMERCE = 2,
  READING = 3,
  LIBRARY_FACILITIES = 4,
  INNOVATION = 5,
}

export enum BizAttrTypeName {
  // TEACHING_MATERIAL = '教材',
  // E_COMMERCE = '电商',
  READING = '阅读',
  LIBRARY_FACILITIES = '馆配',
  INNOVATION = '创新',
}
// 发货类型
export enum ShipmentMethod {
  SELF_INITIATED = 1,
  PROVINCIAL_DISPATCH = 2,
  SUPPLIER_DISPATCH = 3, //2024-12-20.临时隐藏
}

export enum ShipmentMethodName {
  SELF_INITIATED = '自发',
  PROVINCIAL_DISPATCH = '省店代发',
  SUPPLIER_DISPATCH = '供应商一键代发',
}

// 业务模式
export enum BusinessModel {
  WHOLESALE = 1,
  GROUP_BUYING = 2,
  // RETAIL = 3,
}

export enum BusinessModelName {
  WHOLESALE = '批发',
  GROUP_BUYING = '团购',
  // RETAIL = '零售',
}

//订单业务类型
export enum OrderBusinessType {
  NORMAL = 1,
  EXCHANGE = 2,
  REPLENISHMENT = 3,
}
export enum OrderBusinessTypeName {
  NORMAL = '常规',
  EXCHANGE = '换货',
  REPLENISHMENT = '补发',
}
//商品业务类型
export enum ProductBizTypeType {
  NORMAL = 1,
  CARD = 2,
}
export enum ProductBizTypeTypeName {
  NORMAL = '常规',
  CARD = '卡劵',
}

// 配送方式
// 1-自提，2-快递或快运，3-自配送，4-即时配送
export enum DeliveryMethod {
  SELF_PICKUP = 1,
  EXPRESS_DELIVERY = 2,
  SELF_DELIVERY = 3,
  // IMMEDIATE = 4,
}

export enum DeliveryMethodName {
  SELF_PICKUP = '自提',
  EXPRESS_DELIVERY = '快运/快递',
  SELF_DELIVERY = '自配送',
  // IMMEDIATE = '卖场即时',
}

//分发类型
export enum DistributeType {
  DISTRIBUTE_TO_STORE = 3,
  NO_DISTRIBUTION_NEEDED = 4,
}
export enum DistributeTypeName {
  DISTRIBUTE_TO_STORE = '分发到店',
  NO_DISTRIBUTION_NEEDED = '无需分发',
}
//回告上传
export enum CustomerFeedbackStatus {
  ALL_SATISFIED = 0, //全部满足
  PARTIAL_SATISFIED_REMAINING_TO_ORDER = 1, //部分满足，剩余转预定
  PARTIAL_SATISFIED_NO_REPRINT = 2, // 部分满足，剩余不再印刷
  ALL_UNSATISFIED_REMAINING_TO_ORDER = 3, //全部不满足，剩余转预定
  ALL_UNSATISFIED_NO_REPRINT = 4, // 全部不满足，剩余不再印刷
}

export enum CustomerFeedbackStatusName {
  ALL_SATISFIED = '全部满足', //全部满足
  PARTIAL_SATISFIED_REMAINING_TO_ORDER = '部分满足，剩余转预定', //部分满足，剩余转预定
  PARTIAL_SATISFIED_NO_REPRINT = '部分满足，剩余不再印刷', // 部分满足，剩余不再印刷
  ALL_UNSATISFIED_REMAINING_TO_ORDER = '全部不满足，剩余转预定', //全部不满足，剩余转预定
  ALL_UNSATISFIED_NO_REPRINT = '全部不满足，剩余不再印刷', // 全部不满足，剩余不再印刷
}
// 是否挂起
export enum IsHoldStatus {
  NO = 0,
  YES = 1,
}

export enum IsHoldStatusName {
  NO = '否',
  YES = '是',
}

//
export enum OrderProcessingType {
  /**
   * 满足部分发货，其余取消
   */
  PARTIAL_SHIPMENT_REST_CANCEL = 1,

  /**
   * 满足部分发货，其余转预订
   */
  PARTIAL_SHIPMENT_REST_PREORDER = 2,

  /**
   * 不满足，全部订数取消
   */
  NOT_SATISFIED_ALL_CANCEL = 3,

  /**
   * 不满足，全部订数转预订
   */
  NOT_SATISFIED_ALL_PREORDER = 4,
}
export enum OrderProcessingTypeName {
  /**
   * 满足部分发货，其余取消
   */
  PARTIAL_SHIPMENT_REST_CANCEL = '满足部分发货，其余取消',

  /**
   * 满足部分发货，其余转预订
   */
  PARTIAL_SHIPMENT_REST_PREORDER = '满足部分发货，其余转预订',

  /**
   * 不满足，全部订数取消
   */
  NOT_SATISFIED_ALL_CANCEL = '不满足，全部订数取消',

  /**
   * 不满足，全部订数转预订
   */
  NOT_SATISFIED_ALL_PREORDER = '不满足，全部订数转预订',
}

/**
 * 销售单据类型枚举
 */
export enum SaleOrderType {
  /**
   * 1-标准订单
   */
  STANDARD = 1,

  /**
   * 2-直发订单
   */
  DIRECT_DELIVERY = 2,

  /**
   * 3-调剂订单
   */
  ADJUSTMENT = 3,

  /**
   * 4-调价订单
   */
  PRICE_ADJUSTMENT = 4,

  /**
   * 5-代发订单
   */
  CONSIGNMENT = 5,

  /**
   * 6-直发预收订单
   */
  DIRECT_PREPAID = 6,

  /**
   * 7-发退广播订单
   */
  RETURN_BROADCAST = 7,
}
/**
 * 销售单据类型映射
 */
export enum SaleOrderTypeName {
  STANDARD = '标准订单',
  DIRECT_DELIVERY = '直发订单',
  ADJUSTMENT = '调剂订单',
  PRICE_ADJUSTMENT = '调价订单',
  CONSIGNMENT = '代发订单',
  DIRECT_PREPAID = '直发预收订单',
  RETURN_BROADCAST = '发退广播订单',
}
